import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default EnhancedComponent => {
    return class WithCollapsibleCard extends Component {
        static propTypes = {
            isOpen: PropTypes.bool,
            onOpen: PropTypes.func,
        };
        static defaultProps = {
            isOpen: true,
        };
        state = {
            isOpen: this.props.isOpen,
            prevIsOpen: false,
            heightReady: false,
        };

        static getDerivedStateFromProps(nextProps, prevState) {
            const {isOpen: nextIsOpen} = nextProps;
            const {isOpen, prevIsOpen} = prevState;

            if (isOpen !== prevIsOpen) {
                // toggled internal state change
                return {
                    isOpen,
                    prevIsOpen,
                };
            } else if (isOpen !== nextIsOpen) {
                // state change happening because of props change by external component
                return {
                    isOpen: nextIsOpen,
                    prevIsOpen: isOpen,
                };
            }

            return null;
        }

        componentDidUpdate(prevProps, prevState) {
            const {onOpen} = this.props;
            const {isOpen} = this.state;

            if (onOpen && isOpen && !prevState.isOpen) {
                onOpen();
            }
        }

        _onMeasure = () => {
            this.setState({
                heightReady: true,
            });
        };

        _onToggle = evt => {
            evt.preventDefault();

            this.setState((prevState, props) => {
                const {isOpen} = prevState;

                return {
                    isOpen: !isOpen,
                    prevIsOpen: isOpen,
                };
            });
        };

        render() {
            return (
                <EnhancedComponent
                    {...this.props}
                    {...this.state}
                    onMeasure={this._onMeasure}
                    onToggle={this._onToggle}
                />
            );
        }
    };
};
